<template>
  <div class="krs019">
    <div class="top">
      <button type="button" class="btn_trash" @click="deleteGroup">
        {{ $i18nUtil.trans("title.modal.projectClosure","과제 폐쇄") }}
      </button>
      <div class="droplayer icon info tip relative right">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">설명</v-btn>
          </template>
          <div class="dropdown-list">
            <div class="tooltip-b tl" style="width: 373px">
              <div>{{$i18nUtil.trans("message.ProjectManage.001","과제를 폐쇄하면, 1년 후 과제의 모든 데이터가 삭제되어 복원이 불가능합니다.")}}</div>
            </div>
          </div>
        </v-menu>
      </div>
    </div>
    <!-- view 상태 S -->
    <form action="" v-show="viewStatus == 'view'">
      <div class="input-box tit">
        <input
          type="text"
          readonly
          class="ell-singleline"
          onfocus="this.blur();"
          v-model="groupInfo.groupName"
          :placeholder='$i18nUtil.trans("UB001")'
        />
        <button type="reset" class="input-txt-del">입력 삭제</button>
      </div>
      <div class="error" v-if="errorType == 'NO_INPUT'">
        {{$i18nUtil.trans("UB001")}}
      </div>
      <div class="error" v-else-if="errorType == 'BYTE_OVER'">
        {{ $i18nUtil.trans("message.ProjectManage.002","입력 가능한 글자수를 초과하였습니다.") }}
        <span>({{ maxBytes }}byte)</span>
      </div>
      <div class="btn-edit-box">
        <button
          type="button"
          class="btn-primary-small"
          @click="viewStatus = 'edit'"
        >
          {{ $i18nUtil.trans("button.modify","수정") }}
        </button>
      </div>
    </form>

    <form action="" v-show="viewStatus == 'edit'">
      <div class="input-box tit">
        <input
          type="text"
          required
          v-model="resultGroupName"
          :placeholder='$i18nUtil.trans("UB001")'
        />
        <button
          type="reset"
          class="input-txt-del"
          @click="
            errorType = 'NO_INPUT';
            resultGroupName = '';
          "
        >
          입력 삭제
        </button>
      </div>
      <div class="error" v-if="errorType == 'NO_INPUT'">
        {{$i18nUtil.trans("UB001")}}
      </div>
      <div class="error" v-else-if="errorType == 'BYTE_OVER'">
        {{ $i18nUtil.trans("message.ProjectManage.002","입력 가능한 글자수를 초과하였습니다.") }}
        <span>({{ maxBytes }}byte)</span>
      </div>
      <div class="error" v-else-if="errorType == 'OVERLAP'">
        {{ $i18nUtil.trans("UB023") }}
      </div>
      <div class="btn-edit-box">
        <button
          type="button"
          class="btn-primary-small"
          @click="
            viewStatus = 'view';
            resultGroupName = groupInfo.groupName;
          "
        >
          {{ $i18nUtil.trans("button.cancel","취소") }}
        </button>
        <button
          type="button"
          class="btn-primary-small black"
          @click="projectNameCheck()"
        >
          {{ $i18nUtil.trans("button.save","저장") }}
        </button>
      </div>
    </form>
    <ul>
      <li>
        <dl class="clear">
          <dt>{{ $i18nUtil.trans("message.ProjectManage.003","링크 공유") }}</dt>
          <dd>
            <div class="txt">
              {{ url }}
            </div>
            <button
              type="button"
              class="btn-primary-small"
              @click="handlerCopyUrl"
            >
              {{ $i18nUtil.trans("message.ProjectManage.004","링크 복사") }}
            </button>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{ $i18nUtil.trans("message.ProjectManage.005","공개 설정") }}</dt>
          <dd>
            <input
              type="radio"
              name="public"
              id="public1"
              v-model="groupInfo.publicYn"
              @change="handleUpdateConfirm('publicYn1')"
              value="1"
              :disabled="projectInfo.cw"
            /><label for="public1">{{ $i18nUtil.trans("message.ProjectManage.006","전체공개") }}</label>
            <input
              type="radio"
              name="public"
              id="public2"
              v-model="groupInfo.publicYn"
              @change="handleUpdateConfirm('publicYn0')"
              value="0"
            /><label for="public2">{{$i18nUtil.trans("message.ProjectManage.007","과제 멤버만 공개")}}</label>
          </dd>
        </dl>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
  data() {
    return {
      viewStatus: "view",
      url: window.location.href,
      resultGroupName: "",
      errorType: "",
      groupInfo: {
        groupId: null,
        groupName: null,
        groupDesc: null,
        inoutKbn: null,
        publicYn: null,
      },
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      maxBytes: 100,
    };
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState("project", ["projectInfo"]),
    paramEdit() {
      return this.resultGroupName;
    },
  },
  watch: {
    paramEdit: function () {
      let byte = 0;

      for (let i = 0; i < this.resultGroupName.length; ++i) {
        // 기본 한글 2바이트 처리
        this.resultGroupName.charCodeAt(i) > 127 ? (byte += 2) : byte++;
      }
      if (byte > this.maxBytes) { /* 60 > 100 bytes 수정 */
        this.errorType = "BYTE_OVER";
      } else if (this.resultGroupName.length == 0) {
        this.errorType = "NO_INPUT";
      } else {
        this.errorType = null;
      }
    },
  },
  created() {
    this.createdList();
  },
  methods: {
    ...mapMutations("project", ["setProjectInfo"]), // 현재 정보
    ...mapActions("modals", ["showToast"]),
    ...mapActions("modals", ["showModal"]),
    ...mapActions("restAction", ["ASYNC_COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("cooperation", ["updateGroup"]),
    ...mapActions("modals", ["showDialog"]),
    createdList() {
      this.groupInfo.groupId = this.info.groupId;
      this.groupInfo.groupName = this.projectInfo.cogroup.groupName;
      this.resultGroupName = this.projectInfo.cogroup.groupName;
      this.groupInfo.groupDesc = this.projectInfo.cogroup.groupDesc;
      this.groupInfo.inoutKbn = this.projectInfo.cogroup.inoutKbn;
      this.groupInfo.publicYn = String(this.projectInfo.cogroup.publicYn);
      // let obj = this;
      // let reqData = {
      //   url: "/api/cogroup/project/getProjectInfo",
      //   method: "post",
      //   req: {
      //     projectId: this.info.projectId,
      //   },
      // };
      // obj
      //   .COWORK_REST_ACTION(reqData)
      //   .then((data) => {
      //     const list = data.result;
      //     obj.setProjectInfo(list);
      //     obj.groupInfo.groupId = obj.info.groupId;
      //     obj.groupInfo.groupName = list.cogroup.groupName;
      //     obj.resultGroupName = list.cogroup.groupName;
      //     obj.groupInfo.groupDesc = list.cogroup.groupDesc;
      //     obj.groupInfo.inoutKbn = list.cogroup.inoutKbn;
      //     obj.groupInfo.publicYn = String(list.cogroup.publicYn);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     console.log("[정보 오류]");
      //   });
    },
    handleUpdateConfirm(type) {
      if (
        type == "groupName" &&
        (this.errorType != null || this.resultGroupName == "")
      ) {
        // this.resultGroupName = this.groupInfo.groupName;
        // this.viewStatus = "view";
        return;
      }

      let obj = this;
      let reqData = {
        url: "/api/cogroup/project/updateProject",
        method: "post",
        req: {
          groupId: this.info.groupId,
          projectId: this.info.projectId,
          projectName: this.resultGroupName,
          publicYn: String(this.groupInfo.publicYn),
          flag: type,
        },
      };
      obj
        .COWORK_REST_ACTION(reqData)
        .then((data) => {
          if (data.errorCode) {
            console.log(data.errorCode);
          } else {
            obj.groupInfo.groupName = obj.resultGroupName;
            if (type == "groupName") {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB032");
            } else if (type == "publicYn1") {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB031", {
                projectName: obj.groupInfo.groupName,
              });
            } else {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB030", {
                projectName: obj.groupInfo.groupName,
              });
            }
            // else {
            //   obj.toastInfo.message = obj.$i18nUtil.trans("TB055", { evaluationName: type });
            // }
            obj.hideLoadingbar();
            obj.showToast(this.toastInfo);
            obj.viewStatus = "view";
            obj.setProjectInfo(data.result);
          }
          // obj.createdList();
        })
        .catch((err) => {
          console.log(err);
          console.log("[수정 오류]");
        });
    },
    deleteGroup() {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.modal.projectClosure","과제 폐쇄"),
        width: "400px",
        // height: "180px",
        obj: this.$modal,
        contents: this.$i18nUtil.trans("AB021"),
        button: this.$i18nUtil.trans("button.peoject.closure","폐쇄"),
        subButton: this.$i18nUtil.trans("button.dialog.cancel","취소"),
        dialogType: "PROJECT_CLOSURE",
        component: Dialog,
      };
      this.showModal(modalInfo);
    },
    projectNameCheck() {
      let obj = this;

      let regex =/[\"\\"/"\[\]\:\|\<\>\+\=\;\,\?\*\'\@]/g;
      let result = regex.exec(this.resultGroupName);
      if(result != null){
        obj.showAlertDialog(obj.$i18nUtil.trans("AB110"));
        return;
      }

      let reqData = {
        url: "/api/cogroup/cogroup/checkCoGroupName",
        method: "post",
        req: {
          groupName: this.resultGroupName,
        },
      };
      this.showLoadingbar();
      obj
        .ASYNC_COWORK_REST_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            if (
              res.result > 0 &&
              obj.resultGroupName != obj.groupInfo.groupName
            ) {
              obj.errorType = "OVERLAP";
              obj.hideLoadingbar();
            } else {
              obj.handleUpdateConfirm("groupName");
            }
          }
        })
        .catch((err) => {
          console.log("체크 실패");
        });
    },
    handlerCopyUrl(event) {
      let input = document.createElement("input");
      input.setAttribute(
        "value",
        event.srcElement.previousElementSibling.innerText
      );
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      this.toastInfo.message = this.$i18nUtil.trans("TB010");
      this.showToast(this.toastInfo);
      document.body.removeChild(input);
    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/ProjectManage.vue